/**
 * 地址栏里的作业号。
 *
 * 背景：2026-09-11 用户停在诊断那一屏上说「URL 要变换，不然刷新就没了」。在那之前
 *   地址栏自始至终是 `/ripple/`，作业号只活在这一页的内存里：手滑刷新一下，
 *   一张正在跑的图、一道等着他决定的闸、一份已经扣过米粒的成品，全都找不回来，
 *   页面还退回「选一张图」，像什么都没发生过。
 * 设计意图：作业一建起来就把号写进地址栏（`?job=`），刷新、存书签、发给人看
 *   都从这一个参数接回去（见 jobClient 的 attachJob）。
 * 关键约束：
 *   1. `replaceState`，不入历史。作业的每一步都在同一页上推进，若每次都 push，
 *      用户想回到上一页得按十几次后退。
 *   2. 只有真作业写。录像那几屏是 `?state=` 的事，两套参数不混用——
 *      混了之后「这一屏是真是假」就要看两个地方，而那正是最不能猜的一件事。
 *   3. 作业没了（超过 24 小时被清掉）就把这一截也清掉：留着的话每次刷新
 *      都撞同一堵墙，而用户看不出那堵墙是地址栏带来的。
 */
const PARAM = 'job'

export function readJobId(): string | null {
  const v = new URLSearchParams(window.location.search).get(PARAM)
  // 作业号是 `rp-` 加一串 token_urlsafe。挑一眼就能否掉的：别的东西不往下传。
  return v && /^[A-Za-z0-9_-]{4,64}$/.test(v) ? v : null
}

export function writeJobId(id: string | null): void {
  const u = new URL(window.location.href)
  if (u.searchParams.get(PARAM) === (id ?? null)) return
  if (id) u.searchParams.set(PARAM, id)
  else u.searchParams.delete(PARAM)
  window.history.replaceState(null, '', u)
}
